import { userRoutes } from 'modules/user/routes/constants';

export const userResetPasswordRoutes = {
  root: `${userRoutes.root}/reset-password`,
};
